import { IconKeys } from "dash-ui";
import { RoutesPath } from "flow-components/routes/routes";
import { SHOW_API_CONSOLE_IN_SIDEBAR } from "shared/config/features";

export const sidebarItemsList: {
  label: string;
  icon?: IconKeys;
  disabled?: boolean;
  path: string;
}[] = [
  {
    label: "properties",
    icon: "home",
    path: RoutesPath.Properties,
  },
  {
    label: "contentActivity",
    icon: "history",
    path: RoutesPath.ContentActivity,
  },
  {
    label: "featuredProperties",
    icon: "star",
    path: RoutesPath.FeaturedContent,
  },
  {
    label: "organizations",
    icon: "suitcase",
    path: RoutesPath.Organizations,
  },
  {
    label: "marketAreas",
    icon: "mapMarker",
    path: RoutesPath.MarketAreas,
  },
  {
    label: "amenities",
    icon: "checklist",
    path: RoutesPath.Amenities,
  },
  {
    label: "externalSales",
    icon: "chart",
    path: RoutesPath.ExternalSales,
  },
  {
    label: "brokers",
    icon: "artboard",
    path: RoutesPath.Brokers,
  },
  {
    label: "seekers",
    icon: "account",
    path: RoutesPath.Seekers,
  },
  {
    label: "management",
    icon: "setting2",
    path: RoutesPath.Management,
  },
  {
    label: "apiManagement",
    icon: "world",
    path: RoutesPath.APIManagement,
  },
  ...(SHOW_API_CONSOLE_IN_SIDEBAR
    ? [
        {
          label: "apiConsole",
          icon: "world" as IconKeys,
          path: RoutesPath.APIConsole,
        },
      ]
    : []),
];
